import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/Layout/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Progress from './pages/Progress';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Posts from './pages/Posts';
import Pets from './pages/Pets';
import PetDetail from './pages/PetDetail';
import Stories from './pages/Stories';
import Comments from './pages/Comments';
import PostDetail from './pages/PostDetail';
import Categories from './pages/Categories';
import Breeds from './pages/Breeds';
import Sliders from './pages/Sliders';
import Notifications from './pages/Notifications';
import Keywords from './pages/Keywords';
import Reports from './pages/Reports';
import Pages from './pages/Pages';
import FAQs from './pages/FAQs';
import Analytics from './pages/Analytics';
import AdminRoles from './pages/AdminRoles';
import AdminActionLogs from './pages/AdminActionLogs';
import AppSettings from './pages/AppSettings';
import GeoRestrictions from './pages/GeoRestrictions';
import UserConsents from './pages/UserConsents';
import 'antd/dist/reset.css';
import './App.css';

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
        },
      }}
    >
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Routes>
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/progress" element={<Progress />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/users/:id" element={<UserDetail />} />
                      <Route path="/posts" element={<Posts />} />
                      <Route path="/pets" element={<Pets />} />
                      <Route path="/pets/:id" element={<PetDetail />} />
                      <Route path="/stories" element={<Stories />} />
                      <Route path="/comments" element={<Comments />} />
                      <Route path="/posts/:id" element={<PostDetail />} />
                      <Route path="/categories" element={<Categories />} />
                      <Route path="/breeds" element={<Breeds />} />
                      <Route path="/sliders" element={<Sliders />} />
                      <Route path="/notifications" element={<Notifications />} />
                      <Route path="/keywords" element={<Keywords />} />
                      <Route path="/reports" element={<Reports />} />
          <Route path="/pages" element={<Pages />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/admin-roles" element={<AdminRoles />} />
          <Route path="/admin-logs" element={<AdminActionLogs />} />
          <Route path="/settings" element={<AppSettings />} />
          <Route path="/geo-restrictions" element={<GeoRestrictions />} />
          <Route path="/user-consents" element={<UserConsents />} />
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
